export default __webpack_public_path__ + "static/media/ftm.3f8c71bb.svg";